<template>
  <div>
    <div class="cv_list">
      <swiper :options="swiperOptionsVideoNormal">
        <swiper-slide v-for="(item, index) in videoList[id % 3]" :key="index">
          <div class="cvl_item">
            <div class="cvl_img">
              <a :href="'/old-page?id=' + item.id" target="_blank"
                ><img :src="item.src" alt=""
              /></a>
              <div class="time">{{ item.videoDuration }}</div>
            </div>
            <div class="cvl_title">{{ item.title }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-button-next normal-button-next el-icon-arrow-right"
        slot="pagination"
      ></div>
      <div
        class="swiper-button-prev normal-button-prev el-icon-arrow-left"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: Number,
  },
  data() {
    return {
      swiperOptionsVideoNormal: {
        navigation: {
          nextEl: ".normal-button-next",
          prevEl: ".normal-button-prev",
        },
        slidesPerView: 4.6,
      },
      videoList: [
        [
          {
            id: 1,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631944954701_85.jpg",
            title: "森林防火常识",
            videoDuration: "01:44",
          },
          {
            id: 2,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631944929598_85.jpg",
            title: "警示片《家庭火灾防范事故》",
            videoDuration: "08:27",
          },
          {
            id: 3,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631944877708_85.jpg",
            title: "警示片《预防台风事故》",
            videoDuration: "08:42",
          },
          {
            id: 4,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255882982_85.jpg",
            title: "森林消防员的一分钟",
            videoDuration: "02:06",
          },
          {
            id: 5,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255907531_85.jpg",
            title: "为应急车辆让行",
            videoDuration: "03:15",
          },
          {
            id: 6,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255710323_85.jpg",
            title: "化学性皮肤灼伤现场急救方法二",
            videoDuration: "01:11",
          },
        ],
        [
          {
            id: 7,
            src: "http://vphoto.kepuchina.cn/images/2020/6/11/20206111591844702064_76.jpg",
            title: "幸福栏目：诚实的好处",
            videoDuration: "04:53",
          },
          {
            id: 8,
            src: "http://vphoto.kepuchina.cn/images/2020/6/10/20206101591757388796_76.jpg",
            title: "幸福栏目：去冒险",
            videoDuration: "04:53",
          },
          {
            id: 9,
            src: "http://vphoto.kepuchina.cn/images/2020/6/8/2020681591597841729_76.jpg",
            title: "幸福栏目：学会说“不”",
            videoDuration: "02:02",
          },
          {
            id: 10,
            src: "http://vphoto.kepuchina.cn/images/2020/6/5/2020651591334793180_76.jpg",
            title: "幸福栏目：美满婚姻的终极贴士",
            videoDuration: "05:32",
          },
          {
            id: 11,
            src: "http://vphoto.kepuchina.cn/images/2020/6/3/2020631591165569913_76.jpg",
            title: "幸福栏目：如何达到理想生活",
            videoDuration: "11:01",
          },
          {
            id: 12,
            src: "http://vphoto.kepuchina.cn/images/2020/5/28/20205281590636309270_76.jpg",
            title: "幸福栏目：欣赏音乐的作用",
            videoDuration: "08:41",
          },
        ],
        [
          {
            id: 13,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631945114433_85.jpg",
            title: "警示片《冒顶片帮事故》",
            videoDuration: "08:25",
          },
          {
            id: 14,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631945058851_85.jpg",
            title: "汛期安全小贴士",
            videoDuration: "01:00",
          },
          {
            id: 15,
            src: "http://vphoto.kepuchina.cn/images/2021/9/18/20219181631944991681_85.jpg",
            title: "河道安全篇",
            videoDuration: "01:22",
          },
          {
            id: 16,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255838987_85.jpg",
            title: "不可小觑的镁元素",
            videoDuration: "03:00",
          },
          {
            id: 17,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255793138_85.jpg",
            title: "森林固碳的奥秘",
            videoDuration: "03:00",
          },
          {
            id: 18,
            src: "http://vphoto.kepuchina.cn/images/2021/9/10/20219101631255772095_85.jpg",
            title: "金蝉脱壳",
            videoDuration: "03:00",
          },
        ],
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.cv_list {
  position: relative;

  .cvl_item {
    width: 220px;
    margin-right: 35px;

    .cvl_img {
      position: relative;
      width: 100%;
      height: 125px;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
      }

      .time {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0 10px 10px 0;
        @include fontSize(16px, 400, #fff, 22px);
      }
    }

    .cvl_title {
      padding: 10px 0;
      @include fontSize(18px, 400, #353535, 25px);
      @include textoverflow;
    }
  }

  .swiper-container {
    position: relative;
    height: 100%;
  }

  .swiper-button-prev {
    top: 46px !important;
    left: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 0 100px 100px 0;
  }

  .swiper-button-next {
    top: 46px !important;
    right: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 100px 0 0 100px;
  }

  .swiper-button-prev::after {
    content: " ";
    //margin-left: -6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }

  .el-icon-arrow-left::before {
    margin-left: -6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }

  .swiper-button-next::after {
    content: " ";
    //margin-left: 6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }
  .el-icon-arrow-right::before {
    margin-left: 6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
